import { debounce, escapaHtml } from "../utils";
import { client, TYPE_INFO, estado, getQueryFromUrl, renderStars } from "./nucleo";
import { guardarHistorial } from "./historial";

/* ============================================
   🚀 INICIALIZAR SEARCH Y SCROLL
============================================ */
export function initSearchAndScroll() {
    const searchInput = document.getElementById('search-input-alg');
    const searchInputMobile = document.getElementById('search-input-alg-mb');

    if (!searchInput && !searchInputMobile) return;


    const debouncedHandleInputChange = debounce((e) => executeSearch(e.target.value.trim()), 250);
    searchInput?.addEventListener('input', debouncedHandleInputChange);
    searchInputMobile?.addEventListener('input', debouncedHandleInputChange);

    handleSearchFromUrl();

    function handleChangeIndexSelection(select) {
    const index = select.value;
    const query = searchInput ? searchInput.value.trim() : searchInputMobile.value.trim();
    if (query) {
        const params = new URLSearchParams();
        params.set('q', query);
        if (index) params.set('filters', index);
        window.location.href = `/search?${params.toString()}`;
    }
}

    window.handleChangeIndexSelection = handleChangeIndexSelection;
    initHorizontalScroll();
}

/* ============================================
   🖱️ SCROLL HORIZONTAL
============================================ */
function initHorizontalScroll() {
    const horizontalScrollSelectors = [
        '#best-value-section',
        '.mercados-cerca-content',
        '#markets-section',
        '#stores-section',
        '#products-section',
        '#scroll-tiendas-wrapper',
        '#productos-scroll-wrapper',
        '#productos-subcategorias-scroll-wrapper',
        '#pickup-store-section',
        '#home-delivery-section',
        '#courier-delivery-section'
    ];

    const scrollSpeedMap = {
        '#best-value-section': 2,
        '.mercados-cerca-content': 2.5,
        '#markets-section': 2.5,
        '#stores-section': 2.5,
        '#products-section': 2.5,
        '#scroll-tiendas-wrapper': 2.5,
        '#productos-scroll-wrapper': 2.5,
        '#productos-subcategorias-scroll-wrapper': 2.5,
        '#pickup-store-section': 2.5,
        '#home-delivery-section': 2.5,
        '#courier-delivery-section': 2.5,
    };

    horizontalScrollSelectors.forEach(selector => {
        const el = document.querySelector(selector);
        if (!el) return;

        el.addEventListener('wheel', function (e) {
            const hasScroll = el.scrollWidth > el.clientWidth;
            if (hasScroll && window.innerWidth > 768) {
                e.preventDefault();
                const speed = scrollSpeedMap[selector] || 2;
                el.scrollLeft += e.deltaY * speed;
            }
        }, { passive: false });
    });
}

/* ============================================
   🔎 BÚSQUEDA DESDE URL
============================================ */
function handleSearchFromUrl() {
    const searchInput = document.getElementById('search-input-alg');
    const searchInputMobile = document.getElementById('search-input-alg-mb');
    if (!searchInput && !searchInputMobile) return;

    const { query, filters } = getQueryFromUrl();
    if (!query) return;

    let indexName = '';
    if (filters) {
        const indexSelectors = Array.from(document.querySelectorAll('select[name="index-selection"]'));
        indexSelectors.forEach((el) => el.value = filters);
        indexName = `${filters}_index`;
    }

    if (query) {
        searchInput.value = query ?? '';
        searchInputMobile.value = query ?? '';
        searchInput.focus();
        searchInputMobile.focus();
    }

    executeSearch(query, indexName);
}

/* ============================================
   🧠 FUNCIÓN PRINCIPAL DE BÚSQUEDA
============================================ */
async function executeSearch(query, indexName = '') {
    if (!query) {
        resetSections();
        document.getElementById('search-no-results')?.classList.add('hidden');
        document.getElementById('search-no-results-page')?.classList.add('hidden');
        return;
    }

    try {
        const requests = [];

        if (indexName) {
            requests.push({ indexName, query, hitsPerPage: 10 });
        } else {
            requests.push(
                { indexName: 'products_index', query, hitsPerPage: 10 },
                { indexName: 'stores_index',   query, hitsPerPage: 10 },
                { indexName: 'markets_index',  query, hitsPerPage: 10 },
            );
        }

        const response = await client.search({ requests });

        resetSections();
        let hasResults = false;

        const types = indexName ? [ indexName.replace('_index', '') ] : ['products', 'stores', 'markets'];

        response.results.forEach((res, i) => {
            const type = types[i];
            if (res.hits.length > 0) hasResults = true;
            handleResults(res.hits, type);
        });

        document.getElementById('search-no-results')?.classList.toggle('hidden', hasResults);
        document.getElementById('search-no-results-page')?.classList.toggle('hidden', hasResults);

    } catch (err) {
        console.error('Error al buscar:', err);
        resetSections();
        document.getElementById('search-no-results')?.classList.remove('hidden');
        document.getElementById('search-no-results-page')?.classList.remove('hidden');
    }
}

/* ============================================
   🧱 RENDER DE RESULTADOS
============================================ */
function handleResults(data, type, loadMore = false) {
    const sectionInfo = TYPE_INFO[type];
    let noIsMobile = document.getElementById('mobile-search').classList.contains('hidden');

    if (!sectionInfo) return;
    
    
    const modalSection = noIsMobile == true ? document.getElementById(sectionInfo.sectionId) :document.getElementById(sectionInfo.sectionId+'-movil') ; 
    const pageSection = document.getElementById(`page-${type}-section`);

    // 🧱 --- MODAL SECTION ---
    if (modalSection) {
        document.getElementById('content-modal-search').innerHTML = '';
        document.getElementById('content-modal-search-movil').innerHTML = '';
        modalSection.innerHTML = '';

        if (data.length === 0) {
            modalSection.classList.add('hidden');
        } else {
            modalSection.classList.remove('hidden');

            // 📋 Solo lista de nombres
            const list = document.createElement('ul');
            list.className = 'space-y-2 text-left';
            modalSection.appendChild(list);

            data.forEach(hit => {
                const item = document.createElement('li');

                let name =
                    type === 'products' ? hit.name :
                    type === 'stores'   ? hit.nombre_publico_tienda :
                    type === 'markets'  ? hit.name :
                    'Sin nombre';

                const link = document.createElement('a');
                link.className = 'text-coral-600 hover:underline font-medium';
                link.innerText = name;

                link.href = "#"; 
                    link.addEventListener("click", (e) => {
                        e.preventDefault();
                        const search = document.getElementById("search-input-alg") || document.getElementById("search-input-alg-mb");
                        if (search) {
                            search.value = name;
                            window.location.href = `/search?q=${encodeURIComponent(name)}`;
                    }
                });

                item.appendChild(link);
                list.appendChild(item);
            });
        }
    }

    // 🧱 --- PAGE SECTION ---
    if (pageSection && !loadMore) {
        pageSection.innerHTML = '';

        if (data.length === 0) {
            pageSection.classList.add('hidden');
            return;
        }

        pageSection.classList.remove('hidden');

        const title = document.createElement('h3');
        title.className = 'text-xl font-semibold mb-3 text-gray-800 border-b pb-2 w-full text-center';
        title.innerText =
            type === 'products' ? 'Productos' :
            type === 'stores'   ? 'Tiendas'   :
            type === 'markets'  ? 'Mercados'  :
            'Resultados';
        pageSection.appendChild(title);

        const grid = document.createElement('div');
        grid.id = `grid-${type}`;
        if (type === 'products') {
            grid.className = 'flex flex-col gap-3 w-full';
        } else {
            grid.className = 'grid gap-4 sm:grid-cols-2 lg:grid-cols-3 justify-center';
        }
        pageSection.appendChild(grid);

        data.forEach(hit => {
            if (type === 'products') {
                const pCard = document.createElement('div');
                pCard.className = 'card-producto-h';
                pCard.style.cursor = 'pointer';
                pCard.onclick = () => modalProducto(hit.mercado_id, hit.id);
                const precio = hit.precio ? hit.precio.toString().replace('.', ',') : '';
                const medida = hit.precio_medida || '';
                pCard.innerHTML =
                    '<div class="card-producto-h-left">' +
                        '<div class="card-producto-h-img-wrap">' +
                            '<img src="' + escapaHtml(hit.image || hit.imagen || '') + '" alt="' + escapaHtml(hit.name || '') + '" class="card-producto-h-img">' +
                        '</div>' +
                    '</div>' +
                    '<div class="card-producto-h-body">' +
                        '<h3 class="card-producto-h-nombre">' + escapaHtml(hit.name || '') + '</h3>' +
                        (precio ? '<p class="card-producto-h-precio">' + escapaHtml(precio) + (medida ? ' ' + escapaHtml(medida) : '') + '</p>' : '') +
                        (hit.nombreTienda ? '<p class="card-producto-h-desc">' + escapaHtml(hit.nombreTienda) + '</p>' : '') +
                        '<button onclick="event.stopPropagation();modalProducto(' + Number(hit.mercado_id) + ',' + Number(hit.id) + ')" class="card-producto-h-btn">Ver producto</button>' +
                    '</div>';
                grid.appendChild(pCard);
                return;
            }

            const card = document.createElement('div');
            card.className = 'tarjeta-producto';
            const titleTarget = document.createElement('div');
            titleTarget.className = 'title-tarjeta';
            
            let name, descripcion, direccion, url, localidad;

            if (type === 'markets') {  
                name = hit.name;
                localidad = hit.localidad
                direccion = [hit.direccion_1, hit.direccion_2, hit.codigo_postal]
                    .filter(Boolean)
                    .join(', ');
                url = `plazas/${hit.slug ?? hit.id}`;
            } else if (type === 'stores') {
                name = hit.nombre_publico_tienda;
                localidad = hit.localidad_tienda;
                direccion = hit.direccion_descriptiva;
                url = `tienda/${hit.id}`;
            } else {
                name = 'Sin nombre';
                descripcion = 'Sin descripcion';
            }

            titleTarget.innerText = localidad;
            card.appendChild(titleTarget);
            const img = document.createElement('img');
            img.src = hit.image || hit.imagen || '/images/no_image.jpg';
            img.alt = hit.name || hit.title || hit.nombre || 'Sin nombre';
            img.className = 'w-full h-[8.5rem] object-contain max-h-[115px]';
            card.appendChild(img);

            const content = document.createElement('div');
            content.className = 'p-4 flex flex-col flex-1 items-center';

            const titleEl = document.createElement('h4');
            titleEl.className = 'font-semibold text-xs';
            titleEl.innerText = name;
            content.appendChild(titleEl);

            if (hit.precio) {
                const price = document.createElement('p');
                price.className = 'font-bold mb-2';
                const precioFormateado = hit.precio.toString().replace('.', ',');
                price.innerText = `${precioFormateado}${hit.precio_medida || ''}`;
                content.appendChild(price);
            }


            if (hit.score != null && type != 'products') {
                const scoreLink = document.createElement('a');
                scoreLink.href = '#';
                scoreLink.className = 'inline-flex items-center';
                scoreLink.onclick = (e) => {
                    e.preventDefault();
                    openReviewsModal(hit.id);
                };
                const scoreElement = renderStars(hit.score, hit.total_reviews);
                scoreLink.appendChild(scoreElement);
                content.appendChild(scoreLink);
            }

            if (direccion) {
                const desc = document.createElement('p');
                desc.className = 'text-gray-600 text-sm';
                desc.innerText = direccion;
                content.appendChild(desc);
            }

            if (descripcion) {
                const desc = document.createElement('p');
                desc.className = 'text-gray-600 text-sm';
                desc.innerText = descripcion;
                content.appendChild(desc);
            }

            const btn = document.createElement('a');
            btn.href = url;
            btn.className = `boton-caja w-full bg-coral-600 hover:bg-coral-700 text-white font-semibold py-2 px-4 rounded`;
            btn.innerText =
                type === 'stores'  ? 'Ver tienda'  :
                type === 'markets' ? 'Ver mercado' :
                'Ver más';

            card.appendChild(content);
            card.appendChild(btn);
            grid.appendChild(card);
        });
    }else if(pageSection && loadMore){
            const grid = document.getElementById(`grid-${type}`);
            if (!grid) return;

            data.forEach(hit => {
            if (type === 'products') {
                const pCard = document.createElement('div');
                pCard.className = 'card-producto-h';
                pCard.style.cursor = 'pointer';
                pCard.onclick = () => modalProducto(hit.mercado_id, hit.id);
                const precio = hit.precio ? hit.precio.toString().replace('.', ',') : '';
                const medida = hit.precio_medida || '';
                pCard.innerHTML =
                    '<div class="card-producto-h-left">' +
                        '<div class="card-producto-h-img-wrap">' +
                            '<img src="' + escapaHtml(hit.image || hit.imagen || '') + '" alt="' + escapaHtml(hit.name || '') + '" class="card-producto-h-img">' +
                        '</div>' +
                    '</div>' +
                    '<div class="card-producto-h-body">' +
                        '<h3 class="card-producto-h-nombre">' + escapaHtml(hit.name || '') + '</h3>' +
                        (precio ? '<p class="card-producto-h-precio">' + escapaHtml(precio) + (medida ? ' ' + escapaHtml(medida) : '') + '</p>' : '') +
                        (hit.nombreTienda ? '<p class="card-producto-h-desc">' + escapaHtml(hit.nombreTienda) + '</p>' : '') +
                        '<button onclick="event.stopPropagation();modalProducto(' + Number(hit.mercado_id) + ',' + Number(hit.id) + ')" class="card-producto-h-btn">Ver producto</button>' +
                    '</div>';
                grid.appendChild(pCard);
                return;
            }

            const card = document.createElement('div');
            card.className = 'tarjeta-producto';
            const titleTarget = document.createElement('div');
            titleTarget.className = 'title-tarjeta';

            let name, descripcion, direccion, url, localidad;

            if (type === 'markets') {
                name = hit.name;
                localidad = hit.localidad;
                direccion = [hit.direccion_1, hit.direccion_2, hit.codigo_postal]
                    .filter(Boolean)
                    .join(', ');
                url = `plazas/${hit.slug ?? hit.id}`;
            } else if (type === 'stores') {
                name = hit.nombre_publico_tienda;
                localidad = hit.localidad_tienda;
                direccion = hit.direccion_descriptiva;
                url = `tienda/${hit.id}`;
            } else {
                name = 'Sin nombre';
                descripcion = 'Sin descripcion';
            }

            titleTarget.innerText = localidad;
            card.appendChild(titleTarget);

            const img = document.createElement('img');
            img.src = hit.image || hit.imagen || '/images/no_image.jpg';
            img.alt = hit.name || hit.title || hit.nombre || 'Sin nombre';
            img.className = 'w-full h-[8.5rem] object-contain max-h-[115px]';
            card.appendChild(img);

            const content = document.createElement('div');
            content.className = 'p-4 flex flex-col flex-1 items-center';

            const titleEl = document.createElement('h4');
            titleEl.className = 'font-semibold text-xs';
            titleEl.innerText = name;
            content.appendChild(titleEl);

            if (hit.precio) {
                const price = document.createElement('p');
                price.className = 'font-bold mb-2';
                const precioFormateado = hit.precio.toString().replace('.', ',');
                price.innerText = `${precioFormateado}${hit.precio_medida || ''}`;
                content.appendChild(price);
            }

            if (hit.score != null) {
                const scoreLink = document.createElement('a');
                scoreLink.href = '#';
                scoreLink.className = 'inline-flex items-center';
                scoreLink.onclick = (e) => {
                    e.preventDefault();
                    openReviewsModal(hit.id);
                };
                const scoreElement = renderStars(hit.score, hit.total_reviews);
                scoreLink.appendChild(scoreElement);
                content.appendChild(scoreLink);
            }

            if (direccion) {
                const desc = document.createElement('p');
                desc.className = 'text-gray-600 text-xs';
                desc.innerText = direccion;
                content.appendChild(desc);
            }

            if (descripcion) {
                const desc = document.createElement('p');
                desc.className = 'text-gray-600 text-xm';
                desc.innerText = descripcion;
                content.appendChild(desc);
            }

            const btn = document.createElement('a');
            btn.href = url;
            btn.className = `
                mt-auto text-white text-center py-2 rounded-lg font-medium transition
                boton-caja w-[190px] bg-coral-600 hover:bg-coral-700 text-white font-semibold py-2 px-4 rounded
            `;
            btn.innerText =
                type === 'stores'  ? 'Ver tienda'  :
                type === 'markets' ? 'Ver mercado' :
                'Ver más';
            content.appendChild(btn);

            card.appendChild(content);
            grid.appendChild(card);
        });
    }
}

/* ============================================
   🔁 LIMPIAR SECCIONES
============================================ */
function resetSections() {
    ['products', 'stores', 'markets'].forEach(type => {
        const modal = document.getElementById(`${type}-section`);
        const page = document.getElementById(`page-${type}-section`);
        [modal, page].forEach(section => {
            if (!section) return;
            section.classList.add('hidden');
            section.innerHTML = '';
        });
    });
}

function searchOnType() {
    const searchInput = document.getElementById("search-input-alg");
    const searchModal = document.getElementById("search-modal");
    const value = searchInput.value.trim();

    if (!value) {
        searchModal.classList.add("hidden");
        return;
    }


}


['search-input-alg', 'search-input-alg-mb'].forEach(function(id) {
    const input = document.getElementById(id);
    if (input) {
        input.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                const query = this.value.trim();
                if (query) {                 
                    guardarHistorial(query)
                    window.location.href = `/search?q=${encodeURIComponent(query)}`;
                }
            }
        });
    }
});

function getAllActiveFilters() {
    const activeIndexes = [];
    if (document.getElementById('filter_products')?.checked) activeIndexes.push('products');
    if (document.getElementById('filter_stores')?.checked) activeIndexes.push('stores');
    if (document.getElementById('filter_markets')?.checked) activeIndexes.push('markets');

    const filters = { products: [], stores: [], markets: [] };
    const facetFilters = {};
    const numericFilters = { products: [], stores: [] };

    // ✅ Precio
    const priceMin = parseFloat(document.getElementById('filter_price_min')?.value);
    const priceMax = parseFloat(document.getElementById('filter_price_max')?.value);
    if (!isNaN(priceMin)) numericFilters.products.push(`precio>=${priceMin}`);
    if (!isNaN(priceMax)) numericFilters.products.push(`precio<=${priceMax}`);

    // ✅ Valoración
    const rating = document.querySelector('input[name="filter_rating"]:checked')?.value;
    if (rating) numericFilters.stores.push(`score>=${rating}`);
    if (rating) numericFilters.products.push(`score>=${rating}`);

    // ✅ Envío y recogida
    if (document.getElementById('filter_envio')?.checked) {
        filters.markets.push('servicio_envio:1');
        filters.stores.push('envio_rider:1', 'envio_transporte:1', 'entrega_medios_propios:1', 'pedidos_coleccionables:1');
    }

    if (document.getElementById('filter_recogida')?.checked) {
        filters.markets.push('servicio_recogida:1');
        filters.stores.push('entrega_tienda:1', 'recogida_plaza:1');
    }

    // ✅ Provincia
    const provinciaSelect = document.getElementById('filter_provincia');
    const provinciaValue = provinciaSelect?.value.trim();

    if (provinciaValue) {
        filters.stores.push(`provincia_tienda:${provinciaValue}`);
        filters.products.push(`provincia_tienda:${provinciaValue}`);
        filters.markets.push(`localidad:${provinciaValue}`);
    }

    
    ['stores', 'markets', 'products'].forEach(type => {
        if (filters[type].length > 0) facetFilters[type] = [filters[type]];
    });

    return { activeIndexes, facetFilters, numericFilters };
}

window.handleFilterChange = async (loadMore = false) => {
  
    const replicaMap = {
    products: {
        price_asc: "products_index_price_asc",
        price_desc: "products_index_price_desc",
        name_asc: "products_index_name_asc",
        name_desc: "products_index_name_desc",
        rating_desc: "products_index_rating_desc",
        rating_asc: "products_index_rating_asc"
    },
    stores: {
        name_asc: "stores_index_name_asc",
        name_desc: "stores_index_name_desc",
        rating_asc: "stores_index_rating_asc",
        rating_desc: "stores_index_rating_desc",

    },
    markets: {
        name_asc: "markets_index_name_asc",
        name_desc: "markets_index_name_desc",
    }
};
    
    if (!loadMore) estado.currentPage = 0;

    const query = new URLSearchParams(window.location.search).get('q') || '';
    const { activeIndexes, facetFilters, numericFilters } = getAllActiveFilters();
    const sortBy = document.getElementById('sort_by')?.value || 'rating_desc';

    if (!loadMore) resetSections();

    try {
        estado.isLoadingMore = true;


        const requests = activeIndexes.map(type => {
            
            const indexName = replicaMap[type]?.[sortBy] || `${type}_index`;
            return {
                indexName,
                query,
                params: {
                    hitsPerPage: 10,
                    page: estado.currentPage,
                    facetFilters: facetFilters[type]?.length ? facetFilters[type] : undefined,
                    numericFilters: numericFilters[type]?.length ? numericFilters[type] : undefined,
                }
            };
        });

        const response = await client.search(requests);

        let hasResults = false;
        response.results.forEach((res, i) => {
            const type = activeIndexes[i];
            const hits = res.hits;
            if (hits.length > 0) hasResults = true;
            handleResults(hits, type, loadMore);
        });

        document.getElementById('search-no-results-page')?.classList.toggle('hidden', hasResults);

    } catch (err) {
        console.error('Error en búsqueda con filtros:', err);
    } finally {
        estado.isLoadingMore = false;
    }

};

window.toggleFilters = () => {
const content = document.getElementById("filters_content");
    const arrow = document.getElementById("filters_arrow");

    content.classList.toggle("hidden");
    content.classList.toggle("md:block");
    arrow.classList.toggle("rotate-180");
}
